import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, filter, find, map, takeWhile, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { Paginator } from '@app/shared/models/paginator/paginator';
import { EmpleadoInterface, FilterEmpleadoTareas } from '@app/core/interfaces/empleado-interface';
import { RespApi } from '@app/shared/helpers/interfaces/resp-api';
import { AuxiliarService } from '@app/shared/services/auxiliar/auxiliar.service';
import { User } from '@app/core/interfaces/user';
// import { AuthService } from '../auth/auth.service';
import { AuthService } from '@appNeo/neoCore/services/auth/auth.service';
import { RolesIdentificadorEnum } from '@appAuthState/authState/state/auth.store';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LOADER_TRANSPARENT } from '@app/neo/neoCore/interceptors/loaderInterceptor/loader.interceptor';
import { IEstado } from '@app/neo/neoCore/interfaces/IEstado';
import { IRespApi } from '@app/neo/neoShared/helpers/interfaces/IResp-api';



@Injectable({
  providedIn: 'root'
})
export class EmpleadosService {
  nombreEntidad = 'empleados';
  aliasControlador = 'empleado';
  contextLoaderTransparent = { context: new HttpContext().set(LOADER_TRANSPARENT, true) };
  urlEmpleados            = environment.api_base_url + '/empleados';
  urlEmpleadosTiposImagen = environment.api_base_url + '/empleadosTiposImagen';

  public error422Api$: Subject<RespApi> = new Subject<RespApi>();
  
  public empleado$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public empleados$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public empleadosResponsableComercial$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public empleadosJefeProyecto$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public empleadosResponsableTecnico$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public totalEmpleados$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public totalTareas$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService,
    private usuarioService: AuthService
  ) { 

  }

  set empleado(empleado: EmpleadoInterface) {
    this.empleado$.next(empleado);
  }

  set empleados(empleados: EmpleadoInterface[]) {
    this.empleados$.next(empleados);
  }

  getAll(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<EmpleadoInterface[]> {
    let _filtros = filtros;
    if(!_filtros || _filtros && !filtros?.orden) {
      _filtros = {orden: 'nombre', tipoOrden: 'asc'};
    }
    _filtros['idUsuarioEstado'] = '1';
    let request = `${this.urlEmpleados}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(_filtros)}`;
    return this.http.get(request, {}).pipe(
        tap( (data: RespApi )=> {this.empleados$.next( this.mapearEmpleados( data['data']) )}),
        tap( (data: RespApi )=> {this.totalEmpleados$.next( data.total );}),
        map( (data: RespApi) => this.mapearEmpleados( data['data'])) );
  }

  getAllResponsablesComercial(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<EmpleadoInterface[]> {
    let _filtros = {...filtros, idRol: [RolesIdentificadorEnum.MKV_D, RolesIdentificadorEnum.MKV_T, RolesIdentificadorEnum.MKV_C].join(',')}
    return this.getAll(paginatorType, paginator, _filtros)
  }

  getAllResponsablesTecnico(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<EmpleadoInterface[]> {
    let _filtros = { ...filtros, idRol: [RolesIdentificadorEnum.SW_D, RolesIdentificadorEnum.SW_C].join(',') }
    return this.getAll(paginatorType, paginator, _filtros)
  }

  getAllJefeProyecto(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<EmpleadoInterface[]> {
    let _filtros = {...filtros, idRol: [RolesIdentificadorEnum.SW_D, RolesIdentificadorEnum.SW_C].join(',')}
    return this.getAll(paginatorType, paginator, _filtros)
  }

  get(id): Observable<EmpleadoInterface>{
    if ( id !== null) {
      return this.http.get(`${this.urlEmpleados}/${id}`).pipe(
        map((data: EmpleadoInterface[]) => data['data']));
    } else {
      return new Observable<any>( observer => {
        observer.next([]);
        observer.complete();
      });     
    }
  }

  mapearEmpleados( empleados: EmpleadoInterface[] ) {
    if (empleados.length) {
      empleados.forEach((element, index )=> {
        // avatar listado    
        empleados[index].nombre = element.nombreUsuario + ' ' + element.apellidosUsuario;
      });
    }
    return empleados;
  }


  // getTiposImagen() {
  //   return this.http.get(this.urlEmpleadosTiposImagen, {}).pipe(
  //     // tap(data => console.log('Data Tipo imagen: ', data)),
  //     map((data: EmpleadoInterface[]) => data['data']));
  // }



  getEstados(): Observable<IEstado[]> {
    return this.http.get(`${environment.api_base_url}/${this.aliasControlador}Estados`).pipe(
      map((data: IRespApi) => data['data']),
      catchError((err: IRespApi) => {
        console.log('Error ', err);
        return this.handleError(err, `IRequestGetEstados${this.identificadorEntidad}`);
      })
    );
  }

  get identificadorEntidad(): string {
    return this.nombreEntidad.replace(/ /g, "");
  }

   /************************************ 
   * Funciones apoyo                  *
  *************************************/
    // resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<[EmpleadoInterface[], EmpleadoInterface[], EmpleadoInterface[], EmpleadoInterface[]]> {
    //   let paginator = new Paginator();
    //   let paginatorType: TipoPaginadorEnum = TipoPaginadorEnum.offline;  
    //    let peticionEmpledos = this.getAll(paginatorType, paginator);
    //    let peticionEmpledosResponsableComercial = this.getAllResponsablesComercial(paginatorType, paginator);
    //    let peticionEmpledosJefeTecnico = this.getAllResponsablesTecnico(paginatorType, paginator);
    //    let peticionEmpledosResponsableTecnico = this.getAllResponsablesTecnico(paginatorType, paginator);
    //   return forkJoin([peticionEmpledos, peticionEmpledosResponsableComercial, peticionEmpledosJefeTecnico, peticionEmpledosResponsableTecnico]);
    // }
    
  /********************************/
  /* TAREAS POR EMPLEADO       */
  /********************************/
  // PROBLEMA QUE NECESITO EL IDEMPLEADO DEL USUARIO LOGUEADO!!!no endpoint directo

  getTareas(id, paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: FilterEmpleadoTareas, loaderTransparente?: boolean): Observable<any> {
    let paramContext = (loaderTransparente) ? { ...this.contextLoaderTransparent } : {};
    return this.http.get(`${this.urlEmpleados}/${id}/tareas?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`, paramContext)
    .pipe(
      tap((data: RespApi) => { this.totalTareas$.next(data.total); }),
      map((data: RespApi) => {
      return {tareas: data.data, total: data.total} }
    )); 
  }


  getIdEmpleadoUsuario( idUsuario: string): any {
    this.getAll().pipe(
      map(empleados => empleados.filter(empleado => empleado.idUsuario === idUsuario)[0])
    )
  }

  /********************************/
  /* MANEJADOR ERRORES            */
  /********************************/
  public handleError(err: IRespApi, idRequest = '') {
    // control error server con un html ok
    if (err == 'OK') {
      let mensaje = environment.errorServidorSinCodigo;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    if (err == 'Unknown Error') {
      let mensaje = environment.errorServidorUnknown;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    // dialog específico
    err.request = idRequest;
    if (err.codigoError === 422) {
      console.log('Manejador CRUD error 422', err);
      this.error422Api$.next(err);
    }

    // pantalla común
    let mensaje = err?.mensaje;
    if (err.codigoError === 403) {
      mensaje = `${err.mensaje}: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404) {
      let avisos = '';
      if (err.data) {
        if (typeof err.data === 'string') {
          avisos = err.data;
        } else {
          err.data.forEach(element => {
            if (element.id === 999) {
              avisos = ' ' + element.mensaje + ' ';
            }
          });
        }
      }
      mensaje = err?.mensaje + avisos;

    }
    return throwError({ 'error': true, 'data': err.data, mensaje, 'err': err });
  }
}
